import { Voice } from '@/interface/aigc';

export enum SenderType {
  BOT = 1,
  SYSTEM = 2,
  USER = 3,
}

export enum EventType {
  EVENT_TYPE_DEFAULT = 0,
  EVENT_TYPE_MESSAGE = 1,
  EVENT_TYPE_ACTION = 2,
  EVENT_TYPE_EXCL = 3,
}

export enum ContentType {
  CONTENT_TYPE_TEXT = 1,
  CONTENT_TYPE_IMAGE = 2,
  CONTENT_TYPE_AUDIO = 3,
  CONTENT_TYPE_VIDEO = 4,
}

export enum ActionType {
  ACTION_TYPE_DEFAULT = 0,
  ACTION_TYPE_BEGINSCENE = 1,
  ACTION_TYPE_ENDSCENE = 2,
  ACTION_TYPE_SHOWVOICEOVER = 3,
  ACTION_TYPE_SHOWCARD = 4,
  ACTION_TYPE_SHOWCLUE = 5,
  ACTION_TYPE_CHANGEMEDIA = 6,
  ACTION_TYPE_CHANGECLOSENESS = 7,
  ACTION_TYPE_MISSIONCOMPLETED = 8,
  ACTION_TYPE_CHANGECOUNTDOWN = 9,
  ACTION_TYPE_GUIDEREPLY = 10, // 引导回复
}

export enum ChangeMediaOperationType {
  CHANGE_MEDIA_OPERATION_TYPE_DEFAULT = 0,
  CHANGE_MEDIA_OPERATION_TYPE_MODIFY = 1, // 修改
  CHANGE_MEDIA_OPERATION_TYPE_REMOVE = 2, // 移除
}

export enum AssetType {
  ASSET_TYPE_DEFAULT = 0,
  ASSET_TYPE_PLOTCARD = 1, // 剧情卡
  ASSET_TYPE_ITEMSCARD = 2, // 道具卡
}

export enum ChangeMediaType {
  CHANGE_MEDIA_TYPE_DEFAULT = 0,
  CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE = 1, // 背景图
  CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE = 2, // 单人立绘
  CHANGE_MEDIA_TYPE_BGM_AUDIO = 3, // 背景音乐
  CHANGE_MEDIA_TYPE_FULL_VIDEO = 4, // 视频
  CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE = 21, // Spine 立绘
  CHANGE_MEDIA_TYPE_BACKGROUND_VIDEO = 22, // 背景视频
  CHANGE_MEDIA_TYPE_MULTI_CHARACTER = 23, // 多人立绘

  // 以下为前端自己定义的区分类型
  CHANGE_MEDIA_TYPE_PAUSE_BGM_AUDIO = 5,
  REMOVE_FORE_IMAGE = 6,
  REMOVE_BG_IMAGE = 7,
  CHANGE_MEDIA_TYPE_SOUND_EFFECT = 8, // 音效
}

export enum EventToolBarType {
  ADD_BOT = 'add-bot', // 对话
  ADD_SYSTEM = 'add-system', // 旁白
  ADD_FORE_IMAGE = 'add-fore-image', // 单人立绘
  ADD_MULTI_CHARACTER = 'add-multi-character', // 多人立绘
  ADD_SPINE_FORE_IMAGE = 'add-spine-fore-image', // Spine立绘
  ADD_BG_IMAGE = 'add-bg-image', // 背景图
  ADD_VIDEO = 'add-video', // 视频
  ADD_BG_VIDEO = 'add-bg-video', // 背景视频
  ADD_SOUND_EFFECT = 'add-sound-effect', // 音效
  ADD_AUDIO = 'add-audio', // 背景音乐
  ADD_PROPS = 'add-props', // 道具卡

  ADD_IMAGE = 'add-image', // 添加图片
  REMOVE_BG_IMAGE = 'remove-bg-image', // 移除背景图
  REMOVE_FORE_IMAGE = 'remove-fore-image', // 移除单人立绘
  REMOVE_MULTI_CHARACTER = 'remove-multi-character', // 移除多人立绘
  STOP_AUDIO = 'stop-audio', // 停止音频
  ADD_GUIDE_REPLAY = 'add-guide-reply', // 引导回复
  ADD_DRAWER = 'add-drawer', // auto 智能填写
}

export enum ToolBarItemType {
  SYSTEM_TEXT = 'system-text',
  BOT_TEXT = 'bot-text',
  CHANGE_FORE_IMAGE = 'change-fore-image',
  CHANGE_BG_IMAGE = 'change-bg-image',
  CHANGE_BGM_AUDIO = 'change-bgm-audio',
  PAUSE_BGM_AUDIO = 'pause-bgm-audio',
  CHANGE_SOUND_EFFECT = 'change-sound-effect',
  CHANGE_VIDEO = 'change-video',
  SHOW_ITEM = 'show-props',
  ADD_DRAWER = 'add-drawer',
  ADD_GUIDE_REPLAY = 'add-guide-reply', // 引导回复
  ADD_SPINE_FORE_IMAGE = 'add-spine-fore-image', // spine立绘
  ADD_MULTI_CHARACTER = 'add-multi-character', // 多人立绘
}

export const EventToolBarJudge = {
  [EventToolBarType.ADD_BOT]: '对话',
  [EventToolBarType.ADD_SYSTEM]: '旁白',
  [EventToolBarType.ADD_FORE_IMAGE]: '立绘',
  [EventToolBarType.REMOVE_FORE_IMAGE]: '移除立绘',
  [EventToolBarType.ADD_MULTI_CHARACTER]: '多人立绘',
  [EventToolBarType.REMOVE_MULTI_CHARACTER]: '移除多人立绘',
  [EventToolBarType.ADD_BG_IMAGE]: '背景图',
  [EventToolBarType.REMOVE_BG_IMAGE]: '移除背景图',
  [EventToolBarType.ADD_VIDEO]: '视频',
  [EventToolBarType.ADD_BG_VIDEO]: '背景视频',
  [EventToolBarType.ADD_AUDIO]: '背景音乐',
  [EventToolBarType.STOP_AUDIO]: '暂停背景音乐',
  [EventToolBarType.ADD_SOUND_EFFECT]: '音效',
  [EventToolBarType.ADD_PROPS]: '道具',
  props: '道具卡',
  bgm: 'bgm',
  BGM: 'BGM',
  audio: '音频',
  music: '音乐',

  singleCharacter: '单人立绘',
  removeSingleCharacter: '移除单人立绘',
  spine: 'spine',
  Spine: 'Spine',
  SpineText: 'Spine 立绘',
  SPineTextTrim: 'Spine立绘',
  removeSpine: '移除Spine立绘',

  stopbgm: '暂停bgm',
  stopBGM: '暂停BGM',
  stopAudio: '暂停音频',
  stopMusic: '暂停音乐',

  image: '图片', // 默认背景图
  foreImage: '前景图',
};

export enum MissionType {
  MISSION_TYPE_DEFAULT = 0,
  MISSION_TYPE_MAINLINE = 1, // 分支剧情
  MISSION_TYPE_SUCCESS = 2, // 过关剧情
  MISSION_TYPE_FAILURE = 3, // 陷阱剧情
  MISSION_TYPE_PROLOGUE = 4, // 开场剧情
  MISSION_TYPE_ENDING = 5, // 结局剧情

  // 前端自己区分组件使用和服务端协议无关
  MISSION_TYPE_PROPS = 1000, // 道具卡
}

export const MissionTypeNameMap = {
  [MissionType.MISSION_TYPE_DEFAULT]: '默认',
  [MissionType.MISSION_TYPE_PROLOGUE]: '开场剧情',
  [MissionType.MISSION_TYPE_MAINLINE]: '分支剧情',
  [MissionType.MISSION_TYPE_SUCCESS]: '过关剧情',
  [MissionType.MISSION_TYPE_FAILURE]: '陷阱剧情',
  [MissionType.MISSION_TYPE_ENDING]: '结局剧情',
  [MissionType.MISSION_TYPE_PROPS]: '道具卡',
};

export const MissionTabList = [
  {
    label: MissionTypeNameMap[MissionType.MISSION_TYPE_PROLOGUE],
    type: MissionType.MISSION_TYPE_PROLOGUE,
    value: 1,
    tipText: '进入章节后会自动触发该剧情',
  },
  {
    label: MissionTypeNameMap[MissionType.MISSION_TYPE_MAINLINE],
    type: MissionType.MISSION_TYPE_MAINLINE,
    value: 2,
    tipText: '开始创作精彩的剧情吧！',
  },
  {
    label: MissionTypeNameMap[MissionType.MISSION_TYPE_SUCCESS],
    type: MissionType.MISSION_TYPE_SUCCESS,
    value: 3,
    tipText: '章节解锁成功后会触发该剧情',
    limit: 1,
  },
  {
    label: MissionTypeNameMap[MissionType.MISSION_TYPE_FAILURE],
    type: MissionType.MISSION_TYPE_FAILURE,
    value: 4,
    tipText: '章节解锁失败后会触发该剧情',
    limit: 1,
  },
];

export const RELATEDMESSAGE = 'relatedMessages';

export const PLAY_INFO_ID = 'sender_playInfo';

export const RESOURCE_ALL = 'all_id';

export enum MissionTabType {
  BASE = 'base',
  EVENTS = 'event',
  END = 'end'
}

export enum ExclSaveType {
  EXCL_TYPE_DEFAULT = 0,
  EXCL_TYPE_MISSION = 1,
  EXCL_TYPE_SCENE = 2,
}


export interface IEventVoiceList {
  voice: Voice;
  type: SenderType;
  botId?: string;
}
